import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {AreasStyle} from '../../../../../components-shared/Settings/Areas/types'
import {ButtonAlignment, FormLayout, TextAlignment} from '../../../../../types/createStylesParams'

export type LayoutSettingsParams = {
  showTitle: SettingsParamType.Boolean
  showDescription: SettingsParamType.Boolean
  showFormFieldLabels: SettingsParamType.Boolean
  textAlignment: SettingsParamType.String
  buttonAlignment: SettingsParamType.String
  formLayout: SettingsParamType.String
}

export const layoutSettingsParams = createSettingsParams<LayoutSettingsParams>({
  showTitle: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showDescription: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  showFormFieldLabels: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
  },
  textAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Center,
  },
  buttonAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => ButtonAlignment.Stretch,
  },
  formLayout: {
    type: SettingsParamType.String,
    getDefaultValue: () => FormLayout.Packed,
  },
})

export type AreasLayoutSettingsParams = {
  areasStyle: SettingsParamType.String
  areasCardsAlignment: SettingsParamType.String
  areasTextAlignment: SettingsParamType.String
}

export const areasLayoutSettingsParams = createSettingsParams<AreasLayoutSettingsParams>({
  areasStyle: {
    type: SettingsParamType.String,
    getDefaultValue: () => AreasStyle.Cards,
  },
  areasCardsAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Left,
  },
  areasTextAlignment: {
    type: SettingsParamType.String,
    getDefaultValue: () => TextAlignment.Left,
  },
})
